import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { sortSelectOptions } from '../../utils/sort-select-options';

type InputTypes =
  | 'text'
  | 'password'
  | 'email'
  | 'money'
  | 'date'
  | 'datetime-local'
  | 'number'
  | 'mask'
  | 'select'
  | 'select-table'
  | 'search'
  | 'disabled'
  | 'textarea'
  | 'month'
  | 'only-text'
  | 'dropdown';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true
    }
  ]
})
export class InputComponent implements OnInit, OnChanges {
  @Input() type: InputTypes = 'text';
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() readOnly: boolean = false;
  @Input() disabled: boolean = false;
  @Input() maxLength: string | null = null;
  @Input() width: string = '';
  @Input() mask: string = '';
  @Input() name: string = '';
  @Input() min: number | null = null;
  @Input() max: number | null = null;
  @Input() requiredInput: boolean = false;
  /** Quando true, mantém a ordem original das opções (ex.: meses, turnos). */
  @Input() preserveOrder: boolean = false;
  @Input()
  set selectData(value: any[]) {
    this._selectData = Array.isArray(value) ? value : [];
    this.applySelectDataOrder();
  }
  get selectData(): any[] {
    return this.orderedSelectData;
  }
  @Input() ngModel: any;
  @Input() somenteDataFutura: boolean = false;
  @Input() coerceValue: 'string' | 'number' = 'string';
  @Output() ngModelChange: EventEmitter<any> = new EventEmitter();
  @Output() blurEvent: EventEmitter<void> = new EventEmitter();
  passwordType: string = 'password';
  eyeImage: string = 'assets/eye-icon.png';

  value: any = '';
  private _selectData: any[] = [];
  private orderedSelectData: any[] = [];

  onChange: any = () => {};
  onTouched: any = () => {};

  ngOnInit(): void {
    if (this.maxLength === '') {
      this.maxLength = null;
    }

    this.applySelectDataOrder();

    if (
      (this.type === 'select' && this.value === '') ||
      (this.type === 'select-table' && this.value === '')
    ) {
      this.value = '';
      this.onSelectChange(this.value);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['preserveOrder'] && !changes['preserveOrder'].firstChange) {
      this.applySelectDataOrder();
    }
  }

  constructor(private router: Router) {}

  private applySelectDataOrder(): void {
    this.orderedSelectData = this.preserveOrder
      ? [...this._selectData]
      : sortSelectOptions(this._selectData);
  }

  togglePassword() {
    this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
    this.eyeImage = 'assets/eye-icon.png';
  }

  onSelectChange(value: any) {
    let next: any = value === '' ? null : value;

    if (next !== null && this.coerceValue === 'number') {
      const asNumber = Number(next);
      next = Number.isNaN(asNumber) ? null : asNumber;
    }

    this.value = next;
    this.onChange(this.value);
    this.onTouched();
    this.ngModelChange.emit(this.value);
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.readOnly = isDisabled;
    this.disabled = isDisabled;
  }

  onValueChange(value: string | any) {
    if (typeof value === 'string' || typeof value === 'number') {
      this.value = value;
      this.onChange(this.value);
      this.onTouched();
    }

    this.ngModelChange.emit(this.value);
  }

  onFocus() {
    this.onTouched();
  }

  onBlur() {
    this.onTouched();
    this.blurEvent.emit();
  }

  onDateNow() {
    const date = new Date();
    return date.toISOString().slice(0, 16);
  }

  applyMask(event: KeyboardEvent): void {
    const key = event.key;
    const regex = /^[a-zA-ZÀ-ÿ\\s ]*$/;
    if (!regex.test(key)) {
      event.preventDefault();
    }
  }

   handleSelectChange(event: Event): void {
    const raw = (event.target as HTMLSelectElement).value;

    let next: any = raw === '' ? null : raw;

    if (next !== null && this.coerceValue === 'number') {
      const asNumber = Number(next);
      next = Number.isNaN(asNumber) ? null : asNumber;
    }

    this.value = next;
    this.onChange(this.value);
    this.onTouched();
  }
    stringifyValue(v: any): string {
    if (v === null || v === undefined) return '';
    return String(v);
  }
  getNowDateTime(): string {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');

      return `${year}-${month}-${day}T${hours}:${minutes}`;
  }
}
